/** Default stale window for reference-data queries (email templates, defaults, etc.). */
export const REFERENCE_DATA_QUERY_STALE_TIME_MS = 5 * 60 * 1000;
